<div class="cmp-card-latest-messages mb-3 mb-30">
  <div class="card shadow-sm px-4 pt-4 pb-4 rounded">
    <span class="visually-hidden">Categoria:</span>
    <div class="card-header border-0 p-0" *ngIf="formattedTipologia">
      <a
        class="text-decoration-none title-xsmall-bold mb-2 category text-uppercase"
        >{{ formattedTipologia }}</a
      >
    </div>
    <div class="card-body p-0 my-2">
      <h3 class="green-title-big t-primary mb-8">
        <a
          [routerLink]="link"
          [attr.data-element]="dataElement"
          class="text-decoration-none"
          *ngIf="title"
          >{{ title }}</a
        >
      </h3>
      <p class="text-paragraph" *ngIf="description">
        {{ description }}
      </p>
    </div>
  </div>
</div>
